import apiClient from '../utils/apiClient';

/**
 * #232308 — Nhật ký xem SĐT khách: ai đã xem số của khách nào, ở đơn / phiếu đặt
 * bàn nào, lúc nào.
 */
export const customerPhoneViewLogAPI = {
  getLogs: async (params = {}) =>
    await apiClient.get({ url: '/customer-phone-view-log', params }),

  /** Tình trạng ghi nhật ký — dùng để cảnh báo khi nhật ký chết âm thầm. */
  getHealth: async () =>
    await apiClient.get({ url: '/customer-phone-view-log/health' }),
};
